module.exports = __webpack_public_path__ + "static/media/om_wrinkles_weathered.3016e8eb.png";